import './types';

/**
 * @typedef {object} Payload
 * @property {string} filterItem
 * @property {string[]} value
 */

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {Payload} payload - Action payload.
 */
export const setFilterItem = ( draft, payload ) => {
    const { filterItem, value } = payload;
    draft.filters[ filterItem ] = value;
};